import React, { cloneElement, Fragment } from 'react';
import { useCartLine } from '../CartLineProvider';
/**
 * The `CartLineSelectedOptions` component takes a function as a child and calls that function
 * for each of the cart line merchandise's selected options. It must be a descendent of a `CartLineProvider` component.
 */
export function CartLineSelectedOptions(props) {
    const cartLine = useCartLine();
    const { as, children, ...passthroughProps } = props;
    const Wrapper = as ? as : 'ul';
    const ChildWrapper = Wrapper === 'ul' ? 'li' : Fragment;
    return (React.createElement(Wrapper, { ...passthroughProps }, cartLine.merchandise.selectedOptions.map((option) => (React.createElement(ChildWrapper, { key: `${option.name}-${option.value}` }, cloneElement(children(option)))))));
}
